import { SelectPicker } from 'rsuite';
import { ViolationStatus } from '../../../api/rentalscape/__generated_types__/graphql';
import {
  VIOLATION_STATUS_DISABLED_LIST,
  VIOLATION_STATUS_TO_USER_STRING_MAP,
} from '../constants';
import { OnViolationStatusChange, ViolationNode } from '../types';
import { getAllowedStatusTransitions } from '../utils/violation-status-transitions';

interface StatusRendererProps {
  value: ViolationStatus;
  onStatusChange: OnViolationStatusChange;
  data: ViolationNode;
}

export const StatusCellRenderer = ({
  value: currentStatus,
  onStatusChange,
  data,
}: StatusRendererProps) => {
  const allowedTransitions = getAllowedStatusTransitions(currentStatus);

  const statusOptions = allowedTransitions.map((status) => ({
    label: VIOLATION_STATUS_TO_USER_STRING_MAP[status],
    value: status,
  }));

  const handleStatusChange = async (newStatus: ViolationStatus | null) => {
    if (!newStatus || newStatus === currentStatus) return;

    onStatusChange(data.id, newStatus);
  };

  return (
    <SelectPicker
      value={currentStatus}
      data={statusOptions}
      cleanable={false}
      searchable={false}
      className="p-1 text-sm w-36"
      size="md"
      placement="autoVerticalStart"
      disabled={VIOLATION_STATUS_DISABLED_LIST.includes(currentStatus)}
      data-testid="violation-status-select"
      onChange={handleStatusChange}
    />
  );
};
